exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".regions-content{margin-top:30px;max-width:279px;width:100%;border:1px solid #000;padding:13px 18px;overflow-y:auto;height:100%;max-height:259px}.region-item{padding:10px 0}.md-input-has-value{margin-top:8px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/pop-up/pop-up-detail.scss
// module id = 832
// module chunks = 0